const filters = document.querySelector("[data-filters]");

const getFilterData = (filterElements) => {
	let obj = {},
		$checked,
		checkedValues;

	filterElements.each((index, target) => {
		const { type, name, value } = target;

		if (type == "radio" || type == "checkbox") {
			if (!obj[name]) {
				$checked = $(`input[name=${ name }]:checked`);
				checkedValues = [];
				$checked.each((index, target) => {
					checkedValues.push(target.value);
				});

				obj = {
					...obj,
					[name]: checkedValues.join(","),
				};
			}
		} else {
			obj = {
				...obj,
				[name]: value,
			};
		}
	});

	return obj;
};

// Convert object to query string helper
const obj2QueryString = obj => {
	return Object.keys(obj)
		.map(key => {
			return encodeURIComponent(key) + "=" + obj[key]
		})
		.join("&");
}
const queryString2Obj = (str) => {
	if (!str.length) return {};
	const arr = str.split("&");
	const obj = arr.reduce((o, v) => {
		o[v.split("=")[0]] = v.split("=")[1];
		return o;
	}, {});
	return obj;
}

// Ajax new content, and replace existing content
const getContent = filterData => {
	const data = filterData();
	const objQ = queryString2Obj(location.search.substr(1));
	const newQ = {...objQ, ...data};

	// Update current filters
	const newLocation =
		location.origin +
		location.pathname +
		"?" +
		obj2QueryString(newQ);

    // TODO: LOW - REVIEW -- updating location
    // TODO: LOW - AJAX new content
    window.location = newLocation;
    return;
	fetch(newLocation)
		.then(response => {
			history.pushState("", "", newLocation);
			return response.text();
		})
		.then(data => {
			const oldListingContainer = document.querySelector(
				"[data-filtered-content]"
			);
			const parser = new DOMParser();
			const htmlResponse = parser.parseFromString(data, "text/html");
			const newListingContainer = htmlResponse.documentElement.querySelector(
				"[data-filtered-content]"
			);
			oldListingContainer.innerHTML = newListingContainer.innerHTML;
		})
		.catch(error => {
			console.log("🤡");
			console.log(error);
		})
}

// Loop through provided elements and init listeners
const initListeners = (filterElements, filterData) => {
	Array.prototype.forEach.call(filterElements, element => {
		element.addEventListener(
			"change",
			event => {
				getContent(filterData)
			},
			false,
		);
	});
}

const initFilters = filters => {
	if (!filters) {
		return;
	}

	// Check for filters inside our wrapper
	const filterElements = $(filters).find(`select, input`);

	if (!filterElements.length) {
		return;
	}

	// Get current filters in a format ready for zlFetch
	const filterData = () => getFilterData(filterElements);

	// Create listeners for each select, and fire ajax function
	initListeners(filterElements, filterData);
}

initFilters(filters);
